<template>
  <div>
    <v-container fluid class="ma-0 pa-0" >
      <!-- <v-row class="ma-0 pa-0" style="background-color: LightGray;"> -->
      <v-row class="ma-0 pa-0" style="background-image: linear-gradient(to bottom left, #024166, #000e17); min-height: 100vh">
        <v-col sm="12" md="6" align-self="center" >
              <v-row >
                <v-img height="60px" src="../../assets/images/qumulex_logo_white.svg" contain>
                </v-img>
              </v-row>
        </v-col>
        <v-col sm="12" md="6" class="pt-4 ma-0" style="background-color: white; min-height: 100vh">
          <v-row >
            <v-spacer/>
            <v-col cols="10" sm="10" md="8" lg="6">
              <v-row justify="center">
                <v-img 
                  max-height="600px"
                  :class="computedVOffsetClass"
                  :src="tryNowImagePath" >
                </v-img>
              </v-row>
            </v-col>
            <v-spacer/>
            <v-spacer/>
          </v-row>
          <v-row >
            <v-spacer/>
            <v-col cols="10" sm="8" md="8" lg="6">
          <!-- This is the pre-submit form fields -->
        <div v-if="submitted===false" :class="computedTextFieldWidthClass">
              <v-row class="mb-3">
                <h2>
                  Who are we signing up for the trial?
                </h2>
              </v-row>
              <v-row>
                  <v-text-field solo dense
                    v-model="companyName" 
                    label="Company Name"
                    placeholder="Company Name"
                    v-validate.initial="'required'"
                    data-vv-name="companyName"
                    :error-messages="errors.collect('companyName')">
                  </v-text-field>
              </v-row>
              <v-row>
                  <v-text-field solo dense 
                    v-model="email"
                    label="Email Address"
                    placeholder="Email Address"
                    v-validate.initial="'required|email|max:50'" data-vv-name="email"
                    :error-messages="errors.collect('email')">
                  </v-text-field>
              </v-row>
              <v-row>
                  <v-text-field solo dense 
                    v-model="firstName" 
                    label="First Name"
                    placeholder="First Name">
                  </v-text-field>
              </v-row>
              <v-row>
                  <v-text-field solo dense 
                    v-model="lastName" 
                    label="Last Name"
                    placeholder="Last Name">
                  </v-text-field>
              </v-row>
              <v-row>
                  <v-select solo dense 
                    v-model="country" 
                    :items="countries" item-text="name" item-value="code"
                    label="Country"
                    placeholder="Country">
                  </v-select>
              </v-row>
              <v-row>
                  <v-text-field solo dense 
                    v-model="postalCode" 
                    label="Postal Code"
                    placeholder="Postal Code"
                    v-validate="{ required: false, regex: getPostalCodeRegex() }"
                    data-vv-name="postal"
                    :error-messages="errors.collect('postal')">
                  </v-text-field>
              </v-row>
              <v-row>
                <v-btn :disabled="errors.any()" rounded color="primary darken-1" @click="submit">Continue</v-btn>
              </v-row>
          </div>
          <!-- This is the post-submit success/failure notice -->
          <div v-else>
            <v-row v-if="success===true" justify="center">
              <v-img class="my-16" height="150px" src="../../assets/images/transparent-success-icon.png" contain>
              </v-img>
              <p><font size="+1">Registration Successful!</font></p>
            </v-row>
            <v-row v-else justify="center" >
              <v-img class="my-16" height="150px" src="../../assets/images/transparent-warning-icon.png" contain>
              </v-img>
              <a :href="tryAgainLink"><font size="+1">Please Try Again</font></a>
            </v-row>
            <v-row class="mb-16">
              <p v-html=msg></p>
            </v-row>
          </div>
          <!-- End of post-submit success/failure notice and back to common footer -->
              <v-row class="mt-16">
                <p>
                  <small>By continuing, you agree to the Qumulex 
                  <a href="https://www.qumulex.com/terms-of-use">Terms of Use</a>
                  and 
                  <a href="https://www.qumulex.com/privacy-policy">Privacy Policy</a>
                  </small>
                </p>
              </v-row>
            </v-col>
            <v-spacer/>
            <v-spacer/>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

export default {
  name: "Integrator",
  props: {
    app: Object,
    partner: String
  },
  data: () => ({
    companyName: '',
    email: '',
    firstName: '',
    lastName: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    countries: [],
    tryNowPartner: '',
    submitted: false,
    success: false,
    msg: 'success/failure message',
}),

  created() {
    console.log('tryNow.vue created')
},

  mounted() {
    this.submitted = false;
    this.success = false;
    var self = this;
    console.log("tryNow.vue mounted()")
    fetch("https://cdn.jsdelivr.net/npm/country-list@2.2.0/data.json", {
      method: "GET"
    }).then(response => response.json())
      .then(data => {
        console.log(data)
        self.countries = data
        self.countries.sort((a,b) => a.name > b.name ? 1 : -1)
        self.initialize();
      })
  },

  watch: {
    '$route.params': {
      immediate: true,
      handler: function () {
        console.log("route.params.partner: " + this.$route.params.partner);
        if (this.$route.params.partner) {
          this.tryNowPartner = this.$route.params.partner;
        } else {
          this.tryNowPartner = "";
        }
      }
    }
  },

  computed: {
    tryNowImagePath() {
      switch (this.tryNowPartner.toLowerCase()) {
        case "arecont":
          return require('../../assets/images/TryQx.png');
        case "axis":
          return require('../../assets/images/TryAxis.png');
        case "bosch":
          return require('../../assets/images/TryQx.png');
        case "hanwha":
          return require('../../assets/images/TryHanwha.png');
        case "ipro":
          return require('../../assets/images/TryiPro.png');
        case "vivotek":
          return require('../../assets/images/TryVivotek.png');
        default:
          return require('../../assets/images/TryQx.png');
      }
    },
    tryAgainLink() {
      //return env.apiBaseUrl + '/tryqxnow'
      return window.location.origin + '/tryqxnow'
    },
    computedTextFieldWidthClass() {
      let className =  this.$vuetify.breakpoint.mdAndUp ? "shrink_ui_column" : "";
      return className;
    },
    computedVOffsetClass() {
      let className =  this.$vuetify.breakpoint.smAndUp ? "two_column_v_offset" : "";
      //return "";//"two_column_v_offset";
      return className;
    },
  },

  methods: {
    initialize() {
      this.country = "US"
    },

    submit() {
      this.postContact();
      //this.submitted = true
      console.log("tryNow.vue::submit() partner: " + this.tryNowPartner);
    },

    close() {
      this.companyName = ''
      this.customerId = ''
      this.email = ''
      this.firstName = ''
      this.lastName = ''
      this.city = ''
      this.state = ''
      this.country = ''
      this.postalCode = ''
    },

    postContact() {  
      let url = '/API/public/contact/new'
      url += '?'
      url += 'email=' + encodeURIComponent(this.email)
      url += '&companyName=' + encodeURIComponent(this.companyName)
      if (this.firstName !== "") url += '&firstName=' + encodeURIComponent(this.firstName)
      if (this.lastName !== "") url += '&lastName=' + encodeURIComponent(this.lastName)
      if (this.city !== "") url += '&city=' + encodeURIComponent(this.city)
      if (this.state !== "") url += '&state=' + encodeURIComponent(this.state)
      if (this.country !== "") url += '&country=' + encodeURIComponent(this.country)
      if (this.postalCode !== "") url += '&postalCode=' + encodeURIComponent(this.postalCode)
      url += '&listName=' + encodeURIComponent('TryQxNow Contacts')
      console.log('postContact(): url=' + url)
      this.app.restApi({
          method: 'post',
          url: url,
        })
        .then(response => {
          console.log(response)
          console.log(`Successfully created Contact ${this.companyName} (${this.email})`);
          this.postUser();
        })
        .catch( error => {
          if (error.response.status === 409) {
            this.msg = "There is a conflict with email <b>" + this.email + "</b> or company <b>" + this.companyName + "</b>";
          } else {
            this.msg = "Contact could not be created with email <b>" + this.email + "</b>";
            this.msg += ". (" + error.response.status + ")"
          }
          this.submitted = true;
          this.success = false;
        });
    },

    postUser() { 
      let url = '/API/public/contact/user/tryqxnow/new'
      url += '?'
      url += 'email=' + encodeURIComponent(this.email)
      url += '&firstName=' + encodeURIComponent(this.firstName)
      url += '&lastName=' + encodeURIComponent(this.lastName)
      url += '&placeCustomerId=' + encodeURIComponent(this.tryNowPartner.toUpperCase())
      console.log('postUser(): url=' + url)
      this.app.restApi({
          method: 'post',
          url: url,
        })
        .then(response => {
          console.log(response)
          this.success = true;
          this.msg = `Your login information has been sent to:<br><b>${this.email}</b>`;
          this.submitted = true;
          this.success = true;
        })
        .catch( error => {
          if (error.response.status === 409) {
            this.msg = "QxControl user with email <b>" + this.email + "</b> already exists.";
          } else {
            this.msg = "QxControl user could not be created with email <b>" + this.email  + "</b>";
            this.msg += ". (" + error.response.status + ")"
          }
          this.submitted = true;
          this.success = false;
        });
    },

    // https://medium.com/better-programming/how-to-use-vee-validate-to-do-form-validation-e01e9c8b6ac6
    getPostalCodeRegex() {
      if (this.country == "US") {
        return /^[0-9]{5}(?:-[0-9]{4})?$/;
      } else if (this.country == "CA") {
        return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
      }
      return /./;
    },  
    
    getPhoneRegex() {
      if (["US", "CA"].includes(this.country)) {
        return /^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/;
      }
      return /./;
    },
  }
}
</script>

<style scoped>
.shrink_ui_column {
  margin-right: 20%;
  margin-left: 20%;
}
.two_column_v_offset {
  margin-top: 20%;
}
</style>